export const getCollection = /* GraphQL */ `
  query getCollectionByHandle(
    $handle: String!
    $identifiers: [HasMetafieldsIdentifier!]!
    $countryCode: CountryCode
  ) @inContext(country: $countryCode) {
    collectionByHandle(handle: $handle) {
      id
      handle
      title
      description
      updatedAt
      image {
        altText
        url
        src
      }
      metafields(identifiers: $identifiers) {
        id
        key
        namespace
        value
        type
      }
      products(first: 250) {
        nodes {
          id
          handle
          seo {
            title
            description
          }
          title
          description
          descriptionHtml
          availableForSale
          metafields(identifiers: $identifiers) {
            id
            key
            namespace
            value
            type
          }
          featuredImage {
            url
            src
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 5) {
            edges {
              node {
                url
                src
                altText
              }
            }
          }
          tags
          variants(first: 10) {
            nodes {
              id
              title
              currentlyNotInStock
              availableForSale
              sellingPlanAllocations(first: 10) {
                edges {
                  node {
                    sellingPlan {
                      id
                      name
                    }
                  }
                }
              }
              price {
                amount
                currencyCode
              }
              sku
              image {
                url
                src
                altText
              }
              metafields(
                identifiers: [
                  { namespace: "custom", key: "flavor" }
                  { namespace: "custom", key: "flavor_group" }
                ]
              ) {
                id
                key
                namespace
                value
              }
            }
          }
        }
      }
    }
  }
`;
